export default __webpack_public_path__ + "images/b4785375a884163ae196000511444431-wrestling.jpg";